import { useMutation } from '@apollo/client';
import DELETE_OFFLINE_SESSION from 'graphql/mutations/offlineSessions/DeleteOfflineSession.graphql';
import { getIDFromPK } from 'utilities';

export default function useDeleteOfflineSessionMutation() {
  return useMutation(DELETE_OFFLINE_SESSION, {
    update(cache, { data: { deleteOfflineSession } }) {
      if (!deleteOfflineSession) {
        console.warn(
          'Failed to delete an OfflineSession record through GraphQL. It may not exist in the database.',
        );

        return;
      }

      cache.modify({
        fields: {
          offlineSessionsByEpub(existingOfflineSessions, { readField }) {
            const id = getIDFromPK(
              deleteOfflineSession.offlineSessionId,
              'OfflineSessionNode',
            );
            const cacheId = `OfflineSessionNode:${id}`;
            const updatedEdges = existingOfflineSessions.edges.filter(
              (existingOfflineSession) =>
                cacheId !== existingOfflineSession.node.__ref,
            );
            return {
              __typename: existingOfflineSessions.__typeName,
              edges: updatedEdges,
            };
          },
        },
      });
    },
  });
}
